(function() {
	'use strict';
	angular.module('app.leanProjects')
		.controller('viewAssessments', viewAssessmentsReport);

	viewAssessmentsReport.$inject = ['$rootScope', '$scope',  '$timeout', '$translate', '$location',  'leanFilterService', 'tableRenderService', 'tableService', 'ASSESSMENTS', '$state', 'storeService'];

	function viewAssessmentsReport($rootScope, $scope,  $timeout, $translate, $location, leanFilterService, tableRenderService, tableService, ASSESSMENTS, $state, storeService) {
		var vm = this;

		// Redirect to projects if not allowed to current customer
		if (ASSESSMENTS.allowedCustomers.indexOf(globalConfig.customer.id) < 0)  {
			$location.path('/lean-projects/view-projects').replace();
		}

		// Set navigation properties
		$timeout(function(){
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#viewAssessments').addClass('selected');
		}, 0);
		var unsubscribe;
		var scores = [{'id': '5', 'display': '5-Great'}, {'id': '4', 'display': '4'}, {'id': '3', 'display': '3'}, {'id': '2', 'display': '2'}, {'id': '1', 'display': '1-Poor'}];
		var rendererParams = {};
		var reportSettingsName = 'view-assessments';
		var pinnedColumns = [];
		var defaultFilters = [
			{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true }
		];
		// Extra query params to send to backend in data requests
		var extraParams = [{'excelReportName': 'Assessments'}];

		var columns = [{
			id: 'categoryName',
			display: 'Category',
			width: 240,
			enableGrouping: true,
			enablePinning: false,
			grouped: true
		},
		{
			id: 'systemName',
			display: 'System',
			width: 240,
			enableGrouping: false,
			enablePinning: false,
			sort: false
		},
		{
			id: 'elementName',
			display: 'Element',
			width: 240,
			enableGrouping: false,
			enablePinning: false,
			sort: false
		},
		{
			id: 'rating',
			display: 'Score',
			width: 80,
			enableGrouping: false,
			enablePinning: false,
			sort: false,
			renderer: tableRenderService.inlineAssessmentEdit
		},
		{
			id: 'comments',
			display: 'Comments And Actions',
			width: 140,
			enableGrouping: false,
			enablePinning: false,
			sort: false,
			renderer: tableRenderService.inlineAssessmentEdit
		},
		{
			id: 'questionLevel1',
			display: $translate.instant('1-No Evidence of Lean'),
			width: 180,
			enableGrouping: false,
			enablePinning: false,
			sort: false,
			renderer: tableRenderService.assessmentQuestion
		},
		{
			id: 'questionLevel2',
			display: $translate.instant('2-Start-up of Lean'),
			width: 180,
			enableColumnMenu: false,
			enablePinning: false,
			sort: false,
			renderer: tableRenderService.assessmentQuestion
		},
		{
			id: 'questionLevel3',
			display: $translate.instant('3-Implementation with Progress'),
			width: 180,
			enableGrouping: false,
			enablePinning: false,
			sort: false,
			renderer: tableRenderService.assessmentQuestion
		},
		{
			id: 'questionLevel4',
			display: $translate.instant('4-Accelerating Lean and Achieving Results'),
			width: 180,
			enableGrouping: false,
			enablePinning: false,
			sort: false,
			renderer: tableRenderService.assessmentQuestion
		},
		{
			id: 'questionLevel5',
			display: $translate.instant('5-State of the art Company'),
			width: 180,
			enableGrouping: false,
			enablePinning: false,
			sort: false,
			renderer: tableRenderService.assessmentQuestion
		}];

		vm.showExcel = true;
		vm.broadcastExcel = broadcastExcel;
		$scope.filterService = leanFilterService;

		function navigateToBaseReport() {
			$state.go('.', { reportId: undefined });
		}
		vm.navigateToBaseReport = navigateToBaseReport;

		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		if (reportSettingsId) {
			vm.showInfo = true;
		}

		init();
		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: 'Assessments view',
			reportUrl: '{0}/Assessments',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true,
			scores: scores,
			excelReportName: 'Assessments',
			excelRequest: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Assessments view';
		vm.baseReportDisplay = vm.reportName;
		$scope.baseReportName = vm.baseReportDisplay;

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				if (response && response[0]) {
					var count_elementName = 0;
					var count_categoryName = 0;
					var count_systemName = 0;
					var lastCategoryName = '';
					var lastSystemName = '';
					angular.forEach(response[0], function(row) {
						count_elementName = count_elementName + 1;

						if (lastCategoryName !== row.categoryName) {
							count_categoryName = count_categoryName + 1;
							count_systemName = 0;
							count_elementName = 1;
							lastCategoryName = row.categoryName;
						}

						if (lastSystemName !== row.systemName) {
							count_systemName = count_systemName + 1;
							count_elementName = 1;
							lastSystemName =  row.systemName;
							row.systemName = count_categoryName + '.' + count_systemName + '. '
								+ row.systemName;
						} else {
							row.systemName = '';
						}

						row.elementName = count_categoryName + '.' + count_systemName + '.'
							+ count_elementName + '. ' + row.elementName;
						row.categoryName = count_categoryName + '. ' + row.categoryName;
					});
				}
				return response;
			});
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true});
		}

		function init() {
			leanFilterService.clearFilters();
			leanFilterService.useFactoryFilter = true;

			var siteFilter = $scope.filterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;

			$scope.filterService.setMasterFilterList([]);
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});

		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});
	}
})();
